import List from '@mui/material/List';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { SaveAssetDialogTitle } from '../save-asset-dialog/SaveAssetDialogTitle';
import { SearchAssetsInput } from '../common/SearchAssetsInput';
import { SectionsImportLayout } from './SectionsImportLayout';
import { ImportSectionsDialogErrorState } from './ImportSectionsDialogErrorState';
import { ErrorBoundary } from 'react-error-boundary';
import type { ImportSectionsDialogProps } from './ImportSectionsDialogContent.tsx';
import { ImportSectionsDialogContent } from './ImportSectionsDialogContent.tsx';

export function ImportSectionsDialog({ afterSectionId, isOpen, onClose, onImported }: { isOpen: boolean } & ImportSectionsDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <Suspense
        fallback={
          <>
            <SaveAssetDialogTitle title={t('library.import_sections_dialog_title')} onClose={onClose} />

            <SectionsImportLayout.DialogContent>
              <SearchAssetsInput isLoading />
              <List sx={{ overflow: 'hidden' }}>
                <SectionsImportLayout.ListItem isLoading />
                <SectionsImportLayout.ListItem isLoading />
                <SectionsImportLayout.ListItem isLoading />
                <SectionsImportLayout.ListItem isLoading />
                <SectionsImportLayout.ListItem isLoading />
                <SectionsImportLayout.ListItem isLoading />
              </List>
            </SectionsImportLayout.DialogContent>

            <SectionsImportLayout.DialogActions>
              <Button onClick={onClose} color="primary">
                {t('button.cancel')}
              </Button>
              <Button variant="contained" color="primary" disabled>
                {t('library.import_sections_dialog_import_button', { count: 0 })}
              </Button>
            </SectionsImportLayout.DialogActions>
          </>
        }
      >
        <ErrorBoundary
          fallback={
            <>
              <SaveAssetDialogTitle title={t('library.import_sections_dialog_title')} onClose={onClose} />

              <SectionsImportLayout.DialogContent>
                <ImportSectionsDialogErrorState />
              </SectionsImportLayout.DialogContent>

              <SectionsImportLayout.DialogActions>
                <Button onClick={onClose} color="primary">
                  {t('button.cancel')}
                </Button>
              </SectionsImportLayout.DialogActions>
            </>
          }
        >
          <ImportSectionsDialogContent afterSectionId={afterSectionId} onClose={onClose} onImported={onImported} />
        </ErrorBoundary>
      </Suspense>
    </Dialog>
  );
}
